<template>
    <div>
        <header-message>Pending Contact from Technician</header-message>

        <header-message class="mt-5"><fa-icon icon="spinner" class="fa-spin" /></header-message>

        <div class="buttonrow">
            <button-button type="button" class="btn btn-secondary me-2" @click.prevent="cancelClicked">Cancel</button-button>
        </div>
    </div>
</template>

<style scoped lang="scss">
    svg.svg-inline--fa.fa-w-16 {
        width:5rem;
        height:5rem;
    }
</style>

<script lang="ts">
import { defineComponent } from "vue";

import PageBase from "@/shared/components/common/PageBase";
import HeaderMessage from "@/components/HeaderMessage.vue";
import { ButtonClicked } from "@/shared/enums/ButtonClicked";
import { confirmYesNo } from "@/shared/components/common/AlertDialog.vue";
import { CalibrationEventSupport } from "@/support/CalibrationEvent";
import { CalibrationEvent } from "@/shared/enums/CalibrationEvent";
import { SignalR } from "@/support/SignalR";
import { Global } from "@/support/GlobalData";
import { DeviceStatusDto } from "@/shared/models/DeviceStatusDto";

export default defineComponent({
    name: "CalibrationContacting",
    mixins: [PageBase],
    components: {
        HeaderMessage,
    },
    methods: {
        cancelClicked(): void {
            confirmYesNo("Are you sure you want to cancel this calibration?")
                .then((clicked: ButtonClicked): void => {
                    if (clicked === ButtonClicked.Ok) {
                        CalibrationEventSupport.sendEvent(CalibrationEvent.CalibrationCustomerCanceled);
                        Global.MainApp.clearSession();
                        this.$router.push("/");
                    }
                });
        },
        getCurrentStatusForListeners(): void {
            CalibrationEventSupport.sendEventStatus({
                Page: "CalibrationContacting",
            } as DeviceStatusDto);
        }
    },
    mounted(): void {
        SignalR.onGetCurrentStatusForListeners = this.getCurrentStatusForListeners;
        SignalR.onTechnicianConnectedSession = (techName: string): void => {
            this.$router.push("/Calibration/InProgress");
        };
        this.getCurrentStatusForListeners();
        if (Global.IsDemo()) {
            setTimeout((): void => {
                this.$router.push("/Calibration/InProgress");
            }, Number(import.meta.env.VITE_DEMODELAY!) * 1000);
        }
    },
    unmounted(): void {
        SignalR.onGetCurrentStatusForListeners = null;
        SignalR.onTechnicianConnectedSession = null;
    }
});
</script>
